import React from 'react';
import {
  Col, Row, VertContainer,
} from '@vertem-core/vertice-ds';
import SkeletonInput from 'antd/es/skeleton/Input';
import MediaQuery from 'react-responsive';

export const CategoryPageItemsPlaceholder = () => {
  const items = [];
  /* eslint-disable */
  for (let i = 0; i < 12; i++) {
    items.push((
      <SkeletonInput
        key={i}
        active
        rootClassName="col padding-x-extra-small"
        style={{
          height: '511px',
          maxWidth: '33.333vw',
          width: '100%',
          marginBottom: '8px',
          display: 'block',
        }}
      />
    ));
  }

  return items;
};

export const CategoryPageItemsMobilePlaceholder = () => {
  const items = [];
  /* eslint-disable */
  for (let i = 0; i < 8; i++) {
    items.push((
      <SkeletonInput
        key={i}
        active
        rootClassName="col padding-x-extra-small"
        style={{
          height: '50vw',
          maxWidth: '50vw',
          width: '100%',
          marginBottom: '8px',
          display: 'block',
        }}
      />
    ));
  }

  return items;
};
const CategoryPagePlaceholder = () => {
  return (
    <>
      <MediaQuery minWidth={769}>
        <VertContainer className="vert-container-page" spacingX="regular" spacingY="regular">
          <Row justify="center" align="middle" className="vert-category vert-category-title margin-bottom-big" gutter={8}>
            <Col className="vert-category vert-category-title-label col">
              <p>
                <SkeletonInput
                  active
                  rootClassName="col"
                  style={{
                    height: '20px',
                    maxWidth: '100%',
                    width: '280px',
                    marginBottom: '8px',
                    display: 'block',
                  }}
                />
              </p>
              <SkeletonInput
                active
                rootClassName="col"
                style={{
                  height: '20px',
                  maxWidth: '100%',
                  width: '190px',
                }}
              />
            </Col>
            <Col className="vert-category vert-category-title-label col-2">
              <SkeletonInput
                active
                rootClassName="col"
                style={{
                  height: '48px',
                  width: '251px',
                  maxWidth: '100%',
                }}
              />
            </Col>
          </Row>
          <Row justify="center" align="start" className="vert-category vert-category-title margin-bottom-big" gutter={8}>
            <Col className="vert-category vert-category-title-label col-auto">
              <div
                className="vert-template-marketplace vert-sidebar vert-search-sidebar"
              >
                <SkeletonInput
                  active
                  rootClassName="col"
                  style={{
                    height: '548px',
                    width: '100vw',
                    maxWidth: '100%',
                  }}
                />
              </div>
            </Col>
            <Col className="vert-category vert-category-title-label col">
              <div
                className="padding-x-extra-small"
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr 1fr',
                }}
              >
                <CategoryPageItemsPlaceholder />
              </div>
            </Col>
          </Row>
        </VertContainer>
      </MediaQuery>
      <MediaQuery maxWidth={768}>
        <VertContainer className="vert-container-page" spacingX="regular" spacingY="regular">
          <Row justify="center" align="middle" className="vert-category vert-category-title margin-bottom-big" gutter={8}>
            <Col className="vert-category vert-category-title-label col">
              <p>
                <SkeletonInput
                  active
                  rootClassName="col"
                  style={{
                    height: '40px',
                    maxWidth: '100%',
                    width: '150px',
                    marginBottom: '8px',
                    display: 'block',
                  }}
                />
              </p>
            </Col>
            <Col className="vert-category vert-category-title-label col-5">
              <SkeletonInput
                active
                rootClassName="col"
                style={{
                  height: '20px',
                  width: '140px',
                  minWidth: '140px',
                  maxWidth: '100%',
                }}
              />
            </Col>
          </Row>
          <Row justify="center" align="start" className="vert-category vert-category-title margin-bottom-big" gutter={8}>
            <Col className="vert-category vert-category-title-label col">
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                }}
              >
                <CategoryPageItemsMobilePlaceholder />
              </div>
            </Col>
          </Row>
        </VertContainer>
      </MediaQuery>
    </>
  );
};

export default CategoryPagePlaceholder;
